import { WysiwygStandard } from "../../../../modules/wysiwyg/components/WysiwygStandard/WysiwygStandard";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = (props: IWysiwygBlockProps) => {
  if (!props.content) {
    return null;
  }

  return <WysiwygStandard {...props} />;
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
